import type { AppDefinition } from "./OsAppRegistry";

type AppRegistry = Record<string, AppDefinition>;

let registry: AppRegistry | null = null;

/** Called once from ``OsAppRegistry.tsx`` after the registry object is built. */
export function registerAppRegistry(next: AppRegistry): void {
  registry = next;
}

/** Lazy access — avoids importing the full route graph during ``OsContext`` init. */
export function getAppRegistry(): AppRegistry {
  if (!registry) {
    throw new Error("APP_REGISTRY not initialized — import OsAppRegistry first");
  }
  return registry;
}

export function getAppDefinition(appId: string): AppDefinition | undefined {
  return getAppRegistry()[appId];
}
